import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import styles from '../styles/HelpPage.module.css';
import videoBackground from '../styles/background.mp4';

const HelpPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    companyName: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.companyName || !formData.email || !formData.phone || !formData.message) {
      setErrorMessage('All fields are required.');
      return;
    }

    setIsSubmitting(true);
    setErrorMessage('');
    setSuccessMessage('');

    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'https://api-backend.full-trucking-service.com/';
      
      const response = await axios.post(`${apiUrl}/help`, formData, {
        headers: { 'Content-Type': 'application/json' },
      });

      if (response.status === 200) {
        setSuccessMessage('Your request has been submitted successfully. We will contact you shortly.');
        setFormData({ companyName: '', email: '', phone: '', message: '' });
      } else {
        throw new Error('Submission failed.');
      }
    } catch (error) {
      console.error('Error submitting help request:', error);
      setErrorMessage('An error occurred while submitting your request. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.HelpPageContainer}>
      <video className={styles.HelpPageVideoBackground} autoPlay loop muted>
        <source src={videoBackground} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <header className={styles.HelpPageHeaderMenu}>
        <div onClick={() => navigate('/')} className={styles.HelpPageLogo}>
          Full Trucking Service
        </div>
        <nav>
          <ul>
            <li onClick={() => navigate('/about')}>About Us</li>
            <li onClick={() => navigate('/services')}>Services</li>
            <li onClick={() => navigate('/contact')}>Contact</li>
            <li onClick={() => navigate('/pricing')}>Register</li>
          </ul>
        </nav>
      </header>

      <div className={styles.HelpPageContent}>
        <div className={styles.HelpPagetextSection}>
          <h1>Need Help? Contact Us</h1>
          <p>If you have any questions or need assistance, fill out the form below, and our team will get back to you as soon as possible.</p>

          <form className={styles.HelpPageForm} onSubmit={handleSubmit}>
            <label>Company Name:</label>
            <input
              type="text"
              name="companyName"
              placeholder="Enter your company name"
              value={formData.companyName}
              onChange={handleChange}
              required
            />

            <label>Email:</label>
            <input
              type="email"
              name="email"
              placeholder="Enter your email address"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <label>Phone Number:</label>
            <input
              type="tel"
              name="phone"
              placeholder="Enter your phone number"
              value={formData.phone}
              onChange={handleChange}
              required
            />

            <label>Message:</label>
            <textarea
              name="message"
              placeholder="Describe your issue or inquiry"
              value={formData.message}
              onChange={handleChange}
              rows="5"
              required
            />

            {errorMessage && <p className={styles.errorMessage}>{errorMessage}</p>}
            {successMessage && <p className={styles.successMessage}>{successMessage}</p>}

            <button type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Submitting...' : 'Submit Request'}
            </button>
          </form>
        </div>
      </div>

       <footer className={styles.HelpPageFooter}>
            <p onClick={() => navigate('/terms')} className={styles.HelpPagefooterLink}>
              Terms of Service
            </p>
            <p onClick={() => navigate('/privacy')} className={styles.HelpPagefooterLink}>
              Privacy Policy
            </p>
            <p onClick={() => navigate('/help')} className={styles.HelpPagefooterLink}>
              Help
            </p>
           </footer>
    </div>
  );
};

export default HelpPage;
